import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ category }) => {
    return (
        <Link
            to={`/products?category=${category.slug}`}
            className="group block bg-white rounded-lg shadow-sm hover:shadow-md border border-gray-100 overflow-hidden transition-shadow duration-300"
        >
            <div className="aspect-[4/3] overflow-hidden bg-gray-50">
                <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
            </div>
            <div className="p-4 text-center">
                <h3 className="text-brand-blue text-base md:text-lg font-bold mb-1 group-hover:text-brand-red transition-colors">
                    {category.name}
                </h3>
                <p className="text-gray-400 text-xs md:text-sm">
                    {category.itemCount || '2 items'}
                </p>
            </div>
        </Link>
    );
};

export default CategoryCard;
